"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addContractUserShop = addContractUserShop;
exports.countAssignList = countAssignList;
exports.countPendingList = countPendingList;
exports.default = void 0;
exports.delContractUserShop = delContractUserShop;
exports.editContractUserShop = editContractUserShop;
exports.listContractUserShop = listContractUserShop;

var _request = _interopRequireDefault(require("@/utils/request"));

function listContractUserShop(data) {
  return (0, _request.default)({
    url: 'api/contractUserShop',
    method: 'get',
    params: data
  });
} // 待处理改补订单数量


function countPendingList(data) {
  return (0, _request.default)({
    url: 'api/contractUserShop/countPendingList',
    method: 'get',
    params: data
  });
} // 指派处理改补订单数量


function countAssignList(data) {
  return (0, _request.default)({
    url: 'api/contractUserShop/countAssignList',
    method: 'get',
    params: data
  });
} // 新增改补门店


function addContractUserShop(data) {
  return (0, _request.default)({
    url: 'api/contractUserShop',
    method: 'post',
    data: data
  });
} // 修改改补门店


function editContractUserShop(data) {
  return (0, _request.default)({
    url: 'api/contractUserShop',
    method: 'put',
    data: data
  });
} // 删除改补门店


function delContractUserShop(ids) {
  return (0, _request.default)({
    url: 'api/contractUserShop/',
    method: 'delete',
    data: ids
  });
}

var _default = {
  listContractUserShop: listContractUserShop,
  addContractUserShop: addContractUserShop,
  editContractUserShop: editContractUserShop,
  delContractUserShop: delContractUserShop
};
exports.default = _default;